export const talentProfiles = {
  i25bd1n: {
    id: 'i25bd1n',
    name: 'salesleader',
    label: 'Sales Leader',
    profileType: 'leader',
    scoredDimensions: [
      'enzx1e',//performance
      'x3ycav',//strategic
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'ep6tj6',//persuasion
      'y93iyg',//developer
      'c54tc9',//focus
      'u0uvji',//growth
      't9sjaz',//networker
      'jctmmw',//competition
      'moo90r',//persistence
      'p0ruta',//problemsolver
      'lc4930',//relator
      'oyzo55',//responsibility
      'b0e6f1',//mission
      'd22k6w',//operational
      'xmstja',//communication
    ],
    core: true,
    coreProfileId: 'i25bd1n'
  },
  m9zo2d: {
    id: 'm9zo2d',
    name: 'salesmanager',
    label: 'Sales Manager',
    profileType: 'leader',
    scoredDimensions: [
      'enzx1e',//performance
      'g5ii0e',//adaptability,
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'zavm2z',//courage
      'y93iyg',//developer
      'c54tc9',//focus
      'up7jjs',//confidence
      't9sjaz',//networker
      'jctmmw',//competition
      'moo90r',//persistence
      'p0ruta',//problemsolver
      'lc4930',//relator
      'oyzo55',//responsibility
      'fdwtt7',//discipline
      'xmstja',//communication
    ],
    globalBenchmarks: {
      //I think these were pulled from bechtel BD manager - replacing on 12/13/19 with what I recevied for SM benchmarks for dataminr
      // 'enzx1e': 75,//performance
      // 'g5ii0e': 75,//adaptability
      // 'jrsl97': 73,//analytical
      // 'qxgy0i': 78,//learningagility
      // 'zavm2z': 69,//courage
      // 'y93iyg': 80,//developer
      // 'c54tc9': 77,//focus (previously aka direction)
      // 'up7jjs': 71,//confidence
      // 't9sjaz': 69,//networker
      // 'jctmmw': 59,//competition
      // 'moo90r': 73,//persistence
      // 'p0ruta': 79,//problemsolver
      // 'lc4930': 74,//relator
      // 'oyzo55': 79,//responsibility
      // 'fdwtt7': 67,//discipline
      // 'xmstja': 81,//communication
      'enzx1e': 73,//performance
      'g5ii0e': 70,//adaptability
      'jrsl97': 69,//analytical
      'qxgy0i': 72,//learningagility
      'zavm2z': 66,//courage
      'y93iyg': 74,//developer
      'c54tc9': 73,//focus (previously aka direction)
      'up7jjs': 67,//confidence
      't9sjaz': 66,//networker
      'jctmmw': 62,//competition
      'moo90r': 72,//persistence
      'p0ruta': 71,//problemsolver
      'lc4930': 69,//relator
      'oyzo55': 75,//responsibility
      'fdwtt7': 66,//discipline
      'xmstja': 73,//communication
    },
    core: true,
    coreProfileId: 'm9zo2d'
  },
  rreyzmk: {
    id: 'rreyzmk',
    name: 'accountmanager',
    label: 'Account Manager',
    profileType: 'direct',
    scoredDimensions: [
      'enzx1e',//performance
      'g5ii0e',//adaptability,
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'y93iyg',//developer
      'c54tc9',//focus
      'up7jjs',//confidence
      'p0ruta',//problemsolver
      'lc4930',//relator
      'oyzo55',//responsibility
      'vjtt0z',//service
      'fdwtt7',//discipline
      'hp8cen',//team
    ],
    globalBenchmarks: {
      'enzx1e': 73,//performance
      'g5ii0e': 79,//adaptability -> in some cases relabled as strategic
      'jrsl97': 75,//analytical
      'qxgy0i': 71,//learningagility
      'y93iyg': 84,//developer -> in some cases relabled as advisor
      'c54tc9': 78,//focus
      'up7jjs': 77,//confidence
      'p0ruta': 78,//problemsolver
      'lc4930': 82,//relator
      'oyzo55': 80,//responsibility
      'vjtt0z': 82,//service (sometimes relabled as responsiveness or mission)
      'fdwtt7': 74,//discipline
      'hp8cen': 81,//team
    },
    core: true,
    coreProfileId: 'rreyzmk'
  },
  ujehcix: {
    id: 'ujehcix',
    name: 'accountexecutive',
    label: 'Account Executive',
    profileType: 'direct',
    scoredDimensions: [
      'eb2x38',//ambition,
      'g5ii0e',//adaptability,
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'ep6tj6',//persuasion
      'itypp1',//advisor
      'c54tc9',//focus
      'up7jjs',//confidence
      't9sjaz',//networker
      'jctmmw',//competition
      'moo90r',//persistence
      'p0ruta',//problemsolver -> relabled as resourcefulness for this role
      'ltu5rt',//individualizer
      'oyzo55',//responsibility
      'fdwtt7',//discipline
      'hp8cen',//team
    ],
    //TODO THESE ARE JUST PULLED FROM ARROW - I DONT KNOW WHAT THE CORRECT VALUE IS FOR THESE...
    //These got changed on 12/13/19 - I think previous values came from Arrow's complex seller role which was based on account exec. Most values chagned
    //by 0 or 1. This will affect any re-exports of reports that have been exported in 2019. Hopefully we can get all these locked in & documented on sharepoint for 2020
    globalBenchmarks: {
      // 'eb2x38': 74,
      // 'g5ii0e': 72,
      // 'jrsl97': 80,
      // 'qxgy0i': 78,
      // 'ep6tj6': 68,
      // 'itypp1': 84,
      // 'c54tc9': 79,
      // 'up7jjs': 75,
      // 't9sjaz': 70,
      // 'jctmmw': 70,
      // 'moo90r': 77,
      // 'ltu5rt': 74,
      // 'oyzo55': 81,
      // 'fdwtt7': 72,
      // 'hp8cen': 82,
      // 'p0ruta': 77//PHIL NEED TO FIX THIS
      'eb2x38': 75,//Ambition
      'g5ii0e': 73,//Adaptability
      'jrsl97': 80,//Analytical
      'qxgy0i': 79,//Learning Agility
      'ep6tj6': 68,//Persuasion
      'itypp1': 84,//Advisor
      'c54tc9': 79,//Focus
      'up7jjs': 76,//Confidence
      't9sjaz': 70,//Networker
      'jctmmw': 69,//Competition
      'moo90r': 77,//Persistence
      'ltu5rt': 73,//Individualizer
      'oyzo55': 81,//Responsibility
      'fdwtt7': 72,//Discipline
      'hp8cen': 82,//Team
      'p0ruta': 77//Problem Solver / Resourcesfulness
    },
    core: true,
    coreProfileId: 'ujehcix'
  },
  uvagooc: {
    id: 'uvagooc',
    name: 'salesengineer',
    label: 'Sales Technician/Engineer',
    profileType: 'direct',
    scoredDimensions: [
      'eb2x38',//ambition,
      'g5ii0e',//adaptability,
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'zavm2z',//was command => changed to courage on 10/2/19
      'y93iyg',//developer
      'c54tc9',//focus
      'up7jjs',//confidence
      'moo90r',//persistence
      'p0ruta',//problemsolver
      'ltu5rt',//individualizer
      'oyzo55',//responsibility
      'qsptzl',//safety
      'vjtt0z',//service
      'fdwtt7',//discipline
      'hp8cen',//team
    ],
    core: true,
    coreProfileId: 'uvagooc'
  },
  wbsrmp8: {
    id: 'wbsrmp8',
    name: 'salesrep',
    label: 'Sales Representative',
    profileType: 'direct',
    scoredDimensions: [
      'eb2x38',//ambition,
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'c54tc9',//focus
      't9sjaz',//networker
      'moo90r',//persistence
      'p0ruta',//problemsolver
      'lc4930',//relator
      'oyzo55',//responsibility
      'ceokld',//responsiveness
      'fdwtt7',//discipline
      'hp8cen',//team
    ],
    core: true,
    coreProfileId: 'wbsrmp8'
  },
  o1nadu: {
    //Complex Seller role (initially for Arrow)
    id: 'o1nadu',
    name: 'complexseller',
    label: 'Complex Seller',
    profileType: 'direct',
    scoredDimensions: [
      'eb2x38',//ambition
      'up7jjs',//confidence
      'jctmmw',//competition
      'moo90r',//persistence
      'ceokld',//responsiveness **this is different form account exec

      'g5ii0e',//adaptability
      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'p0ruta',//problemsolver / resourcefulness

      't9sjaz',//networker
      'ltu5rt',//individualizer
      'itypp1',//advisor
      'hp8cen',//team

      'c54tc9',//focus
      'ep6tj6',//persuasion
      'oyzo55',//responsibility
      'fdwtt7',//discipline
    ],
    //could pull from "base" role -> relavent dimensions
    //these will NOT be custom and will be updated for core roles quarterly
    //top 20% account executives based on total score, => dimension score averages across this sample
    globalBenchmarks: {
      'eb2x38': 74,//74 is mean avg of all eb2x38 questions for top 20% of people
      'g5ii0e': 72,
      'jrsl97': 80,
      'qxgy0i': 78,
      'ceokld': 71,
      'ep6tj6': 68,
      'itypp1': 84,
      'c54tc9': 79,
      'up7jjs': 75,
      't9sjaz': 70,
      'jctmmw': 70,
      'moo90r': 77,
      'x47kw5': 77,
      'ltu5rt': 74,
      'oyzo55': 81,
      'fdwtt7': 72,
      'hp8cen': 82,
      //TODO fix missing p0ruta - THIS IS A PLACEHOLDER AND IS NOT REAL
      'p0ruta': 77//PHIL NEED TO FIX THIS
    },
    //each client will have their own version of these, even if they are just using
    //dimension score averages of individuals identified as high performers.
    highPerformerBenchmarks: {
      'eb2x38': 74,
      'g5ii0e': 72,
      'jrsl97': 80,
      'qxgy0i': 78,
      'ceokld': 71,
      'ep6tj6': 68,
      'itypp1': 84,
      'c54tc9': 79,
      'up7jjs': 75,
      't9sjaz': 70,
      'jctmmw': 70,
      'moo90r': 77,
      'x47kw5': 77,
      'ltu5rt': 74,
      'oyzo55': 81,
      'fdwtt7': 72,
      'hp8cen': 82,
    },
    isCustom: true,
    coreProfileId: 'ujehcix'
  },
  cl7f8o: {
    //Channel Seller role (initially for Arrow)
    id: 'cl7f8o',
    name: 'channelseller',
    label: 'Channel Seller',
    profileType: 'indirect',
    scoredDimensions: [
      'enzx1e',//performance
      'moo90r',//persistence
      'up7jjs',//confidence
      'jctmmw',//competition

      'ltu5rt',//individualizer
      'hp8cen',//team -> should be labeled as "collaborator"
      't9sjaz',//networker -> labeled as connector
      'itypp1',//advisor

      'jrsl97',//analytical
      'p0ruta',//problemsolver -> relabled as "resourcefulness"
      'g5ii0e',//adaptability -> relabeld as "innovation"
      'qxgy0i',//learningagility

      'c54tc9',//focus
      'ep6tj6',//persuasion
      'oyzo55',//responsibility
      'fdwtt7',//discipline
    ],
    globalBenchmarks: {
      'enzx1e': 72,
      'moo90r': 75,
      'up7jjs': 74,
      'jctmmw': 69,

      'ltu5rt': 76,
      'hp8cen': 76,
      't9sjaz': 72,
      'itypp1': 78,

      'jrsl97': 75,
      'p0ruta': 76,
      'g5ii0e': 74,
      'qxgy0i': 77,

      'c54tc9': 78,
      'ep6tj6': 69,
      'oyzo55': 75,
      'fdwtt7': 70,

    },
    highPerformerBenchmarks: {
      'enzx1e': 73,
      'moo90r': 71,
      'up7jjs': 69,
      'jctmmw': 65,

      'ltu5rt': 70,
      'hp8cen': 74,
      't9sjaz': 70,
      'itypp1': 76,

      'jrsl97': 72,
      'p0ruta': 72,
      'g5ii0e': 72,
      'qxgy0i': 71,

      'c54tc9': 72,
      'ep6tj6': 65,
      'oyzo55': 75,
      'fdwtt7': 65,
    },
    isCustom: true,
    coreProfileId: 'ujehcix'
  },
  vkd3sp: {
    id: 'vkd3sp',
    name: 'bechtelmanagerm&bd',
    label: 'Manager of M&BD',
    profileType: 'leader',
    scoredDimensions: [
      'enzx1e',//performance
      'u0uvji',//growth
      'moo90r',//persistence -> should be labeled as resilience
      'jctmmw',//competition

      'xmstja',//communication -> should be labeled "communicator"
      'y93iyg',//developer
      'lc4930',//relator
      'tuuwro',//customer focus

      'c54tc9',//focus
      'ep6tj6',//persuasion
      'oyzo55',//responsibility -> should be labeled "accountability"
      'd22k6w',//operational

      'x3ycav',//strategic
      'jrsl97',//analytical
      'p0ruta',//problemsolver
      'qxgy0i',//learningagility

    ],
    globalBenchmarks: {
      'enzx1e': 72,//performance
      'u0uvji': 70,//growth
      'moo90r': 73,//persistence -> should be labeled as resilience
      'jctmmw': 64,//competition

      'xmstja': 83,//communication -> should be labeled "communicator"
      'y93iyg': 77,//developer
      'lc4930': 76,//relator -> should be labeled "customer focus"
      'tuuwro': 72,//will pull #s from service/quality?

      'c54tc9': 75,//focus
      'ep6tj6': 68,//persuasion
      'oyzo55': 77,//responsibility -> should be labeled "accountability"
      'd22k6w': 64,//operational

      'x3ycav': 72,//strategic
      'jrsl97': 68,//analytical
      'p0ruta': 71,//problemsolver
      'qxgy0i': 74,//learningagility
    },
    coreProfileId: 'i25bd1n',
    isCustom: true,
  },
  athdcx: {
    id: 'athdcx',
    name: 'bechtelbdmanager',
    label: 'Business Development Manager',
    profileType: 'leader',
    scoredDimensions: [
      'enzx1e',//performance
      'up7jjs',//confidence
      'moo90r',//persistence
      'jctmmw',//competition

      't9sjaz',//networker
      'lc4930',//relator
      'y93iyg',//developer
      'xmstja',//communication -> should be labeled "collaborator"
      'tuuwro',//customer focus (will be created w/ traditionally "service" questions)
      //for bechtel, we need to delete all service questions

      'c54tc9',//focus
      'ep6tj6',//persuasion (unique to this role - usually courage)
      'oyzo55',//responsibility -> should be labeled as "accountability"
      'fdwtt7',//discipline

      'g5ii0e',//adaptability,
      'jrsl97',//analytical
      'p0ruta',//problemsolver
      'qxgy0i',//learningagility

    ],
    globalBenchmarks: {
      'enzx1e': 75,//performance
      'up7jjs': 71,//confidence
      'moo90r': 73,//persistence
      'jctmmw': 59,//competition

      't9sjaz': 69,//networker
      'lc4930': 74,//relator
      'y93iyg': 80,//developer
      'xmstja': 81,//communication -> should be labeled "collaborator"
      'tuuwro': 76,//customer focus

      'c54tc9': 77,//focus
      'ep6tj6': 69,//persuasion
      'oyzo55': 79,//responsibility -> should be labeled as "accountability"
      'fdwtt7': 67,//discipline

      'g5ii0e': 75,//adaptability,
      'jrsl97': 73,//analytical
      'p0ruta': 79,//problemsolver
      'qxgy0i': 78,//learningagility
    },
    coreProfileId: 'm9zo2d',
    isCustom: true,
  },
  z9343r: {
    id: 'z9343r',
    name: 'bechtelbdassociate',
    label: 'Business Development Associate',
    profileType: 'direct',
    scoredDimensions: [
      'eb2x38',//ambition,
      'moo90r',//persistence
      'ceokld',//responsiveness

      't9sjaz',//networker
      'hp8cen',//team -> should be labeled as "collaborator"
      'lc4930',//relator

      'c54tc9',//focus
      'fdwtt7',//discipline
      'oyzo55',//responsibility -> should be labeled as "accountability"

      'jrsl97',//analytical
      'p0ruta',//problemsolver
      'qxgy0i',//learningagility
    ],
    globalBenchmarks: {
      'eb2x38': 73,//ambition,
      'moo90r': 72,//persistence
      'ceokld': 78,//responsiveness

      't9sjaz': 76,//networker
      'hp8cen': 83,//team -> should be labeled as "collaborator"
      'lc4930': 81,//relator

      'c54tc9': 78,//focus
      'fdwtt7': 74,//discipline
      'oyzo55': 82,//responsibility -> should be labeled as "accountability"

      'jrsl97': 72,//analytical
      'p0ruta': 82,//problemsolver
      'qxgy0i': 79,//learningagility
    },
    coreProfileId: 'wbsrmp8',
    isCustom: true
  },
  //Two LPL Financial Profiles
  //Apparently this is an indirect sales leader
  ku39lm: {
    id: 'ku39lm',
    name: 'businesspracticeconsultant',
    label: 'Business Practice Consultant',
    profileType: 'indirect',
    scoredDimensions: [
      'enzx1e',//performance
      'up7jjs',//confidence
      'moo90r',//persistence
      'jctmmw',//competition

      'itypp1',//advisor -> labeled as "consultant"
      'ltu5rt',//individualizer
      'hp8cen',//team -> labled as "collaborator"
      't9sjaz',//networker -> labeled as connector

      'jrsl97',//analytical -> should be labeled "business thinking"
      'qxgy0i',//learningagility
      'p0ruta',//problemsolver
      'x3ycav',//strategic

      'oyzo55',//responsibility
      'ep6tj6',//persuasion
      'fdwtt7',//discipline
      'c54tc9',//focus
    ],
    globalBenchmarks: {
      'enzx1e': 74,//performance
      'up7jjs': 75,//confidence
      'moo90r': 77,//persistence
      'jctmmw': 70,//competition

      'itypp1': 84,//advisor -> labeled as "consultant"
      'ltu5rt': 74,//individualizer
      'hp8cen': 82,//team -> labled as "collaborator"
      't9sjaz': 70,//networker -> labeled as connector

      'jrsl97': 80,//analytical -> should be labeled "business thinking"
      'qxgy0i': 78,//learningagility
      'p0ruta': 77,//problemsolver
      'x3ycav': 72,//strategic

      'oyzo55': 81,//responsibility
      'ep6tj6': 68,//persuasion
      'fdwtt7': 72,//discipline
      'c54tc9': 79,//focus
    },
    coreProfileId: 'i25bd1n',//WILL NOT BE CUSTOM WHEN WE ADD NEW PROFILE
    isCustom: true,//WILL NOT BE CUSTOM WHEN WE ADD NEW PROFILE
  },
  ufrhwl: {
    id: 'ufrhwl',
    name: 'relationshipmanager',
    label: 'Relationship Manager',
    profileType: 'indirect',
    scoredDimensions: [
      'eb2x38',//ambition
      'up7jjs',//confidence
      'moo90r',//persistence
      'ceokld',//responsiveness

      'itypp1',//advisor -> labeled as "coach"
      'ltu5rt',//individualizer
      'hp8cen',//team
      't9sjaz',//networker

      'jrsl97',//analytical
      'qxgy0i',//learningagility
      'p0ruta',//problemsolver
      'g5ii0e',//adaptability

      'oyzo55',//responsibility
      'ep6tj6',//persuasion
      'fdwtt7',//discipline
      'c54tc9',//focus

    ],
    globalBenchmarks: {
      'eb2x38': 72,//ambition
      'up7jjs': 74,//confidence
      'moo90r': 75,//persistence
      'ceokld': 71,//responsiveness

      'itypp1': 78,//advisor -> labeled as "coach"
      'ltu5rt': 76,//individualizer
      'hp8cen': 76,//team
      't9sjaz': 72,//networker

      'jrsl97': 75,//analytical
      'qxgy0i': 77,//learningagility
      'p0ruta': 76,//problemsolver
      'g5ii0e': 74,//adaptability

      'oyzo55': 75,//responsibility
      'ep6tj6': 69,//persuasion - in the most recent power point for LPL, this is 67, not 69!
      'fdwtt7': 70,//discipline
      'c54tc9': 77,//focus
    },
    coreProfileId: 'ujehcix',//Account Executive
    isCustom: true,
  }
}



// WEBPACK FOOTER //
// ./src/data/talentProfiles.js